/**
 * @providesModule Alert
 */

import {type AlertButton, type AlertStatic} from 'react-native';
import {customAlert} from '@/components/atoms/CustomAlert';

class WebAlert implements Pick<AlertStatic, 'alert'> {
  public alert(title: string, message?: string, buttons?: AlertButton[]): void {
    customAlert(title, message, buttons).then(() => {});
    return;
  }
}

const webAlert = new WebAlert();

export default webAlert;
